/** @format */

import React, { useEffect, useState } from "react";
import { FaArrowLeft } from "react-icons/fa";
import { useAuth } from "../context/AuthContext";

const Modal = () => {
  const { showModal, setShowModal } = useAuth();
  const [modalContent, setModalContent] = useState();

  const handleCloseModal = () => {
    setShowModal(null);
  };

  useEffect(() => {
    const getData = JSON.parse(sessionStorage.getItem("showProfile"));
    setModalContent(getData);

    return () => {};
  }, [showModal]);

  if (showModal) {
    return (
      <div className="modal__backdrop">
        <div className="modal__content">
          <img src={modalContent?.url} alt="Profile Picture" />
        </div>
        <div className="close__modal">
          <FaArrowLeft onClick={handleCloseModal} />
          <p>
            {modalContent?.firstName ?? "undefined"} {" "}
            {modalContent?.lastName}
          </p>
        </div>
      </div>
    );
  } else {
    return <></>;
  }
};

export default Modal;
